// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2QPDz","title":"ClientReferral_title__2X1GI","itemText":"ClientReferral_itemText__2tFc8"};